/*
* Author: LJH
* Date: 2022/1/6
* Description:
*/
export default {
  isAQMAPP: typeof navigator !== 'undefined' && /AQUMON-(IOS|ANDROID2|ANDROID)-APP/.test(navigator.userAgent.toUpperCase())
}
